import React from "react";
import Navigation from "../../Component/Navigation";

const Formule = () => {
  return (
    <section>
      <Navigation />
      <div className="global_formule">
        <img
          src="./Media/PT-site.jpg"
          alt="fond-coach"
          className="fond_site_coach"
        />
        <div className="annonce">
          {" "}
          <h2>
            Service à la Personne <span>-50%</span> sur vos impôts !
          </h2>
        </div>
        <div className="bloc1_formule">
          <div className="bloc2_formule">
            <div className="prise_perte">
              <img src="./Media/prise_perte.png" alt="prise-perte" />
              <h3>
                Perte/Prise <br />
                de <br />
                masse
              </h3>
            </div>
            <div className="paroie"></div>
            <div className="prise_perte_tarif">
              <h3>
                <span>Planification sur 12 semaines</span> <br />
                <br />
                <span className="prix">600€</span> <br />
                <br />
                Programmes Sport + Diete + 4 cours visios
              </h3>
            </div>
          </div>

          <div className="bloc2_formule">
            <div className="programme">
              <img src="./Media/programme.png" alt="programme" />
              <h3>Programme</h3>
            </div>
            <div className="paroie"></div>
            <div className="programme_tarif">
              <h3>
                <span>Spotif</span>
                <br /> 80€ /4 semaines
              </h3>
              <br />
              <br />
              <br />
              <br />
              <h3>
                <span>Nutrition</span>
                <br /> 90€ /4 semaines
              </h3>
            </div>
          </div>

          <div className="bloc2_formule">
            <div className="sur_mesure">
              <img src="./Media/athlète.png" alt="athlète" />
              <h3>
                Coaching <br /> à <br /> Domicile
              </h3>
            </div>
            <div className="paroie"></div>
            <div className="sur_mesure_tarif">
              <h3>
                <span>Bordeaux</span> <br />
                <br />
                Me Contacter
              </h3>
            </div>
          </div>
        </div>
        <div className="contact">
          <a href="tel:+33770390083" target="_blank" rel="noopener noreferrer">
            <i className="fa fa-phone" aria-hidden="true"></i>
          </a>
          <a
            href="https://www.instagram.com/personnel_perf/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i class="fa fa-instagram" aria-hidden="true"></i>
          </a>
          <a
            href="mailto:senechal.thibaut@hotmail.fr"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fa fa-envelope" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Formule;
